module.exports = __webpack_public_path__ + "static/images/d60132b8d12930cd79093779501bf808.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/companyDefault.jpg
// module id = 1831
// module chunks = 0